module.exports = __webpack_public_path__ + "img/generalInformation.48a4c5c1.svg";